import React from 'react'
import View from './view'

const CommunitySingle = ({ ...props }) => {
    return <View {...props} />
}

export default CommunitySingle
